<template>
    <div class="pcTips">
        <el-dialog title="提示" :modal="false" :visible.sync="dialogVisible" width="70%" top="30vh" :show-close="false">
            <span>请到电脑端操作</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false
        }
    },
    watch:{
    },
    created() {

    },
    methods: {
        showTips() {
            this.dialogVisible = true
        },
        close(){
            this.dialogVisible = false
        }

    }
}
</script>
<style lang="less" scoped>

/deep/.el-dialog {
    border-radius: 8px;
}

/deep/.el-dialog__body {
    padding: 8px 20px;
}
</style>